<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">
    <vs-popup class="holamundo" :title="$t('USER.resetPassword')" :active.sync="showResetPasswordModal">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="items-center justify-end">
            <ul class="demo-alignment items-center justify-center">
              <li>
                <vs-radio v-model="resetPasswordOption" :vs-value="1">{{ $t('USER.sendLinkByEmail') }}</vs-radio>
              </li>
              <li>
                <vs-radio v-model="resetPasswordOption" :vs-value="2">{{ $t('USER.manuallyChange') }}</vs-radio>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="vx-row" v-show="resetPasswordOption == 2">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full mt-4" :label="$t('USER.newPassword')" v-model="newPassword" name="newPassword"
            type="password" />
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-4">
            <vs-input class="w-full mt-4" :label="$t('USER.confirmNewPassword')" v-model="retypeNewPassword"
              name="retypeNewPassword" type="password" />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-checkbox v-show="this.resetPasswordOption == 2"
              v-model="forceUserToChange">{{ $t('USER.requestPasswordChangeOnLogin') }}</vs-checkbox>
            <vs-button class="ml-auto mt-2" @click="resetUserPassword">{{ $t('USER.add') }}</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>


    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length
                - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} {{
                  $t('USER.of') }} {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="pageSize = 10; currentPageLocal = 1">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="pageSize = 20; currentPageLocal = 1">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="pageSize = 25; currentPageLocal = 1">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="pageSize = 30; currentPageLocal = 1">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
          @input="updateSearchQuery" :placeholder="$t('USER.search')" />
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle"
          @click="$router.push('/users/add')">{{ $t('USER.add') }}</vs-button>
      </div>
      <!-- AgGrid Table -->
      <vs-table class="w-100 my-4" :data="pagedUsers">

        <template slot="thead">
          <vs-th>{{ $t('USER.email') }}</vs-th>
          <vs-th>{{ $t('USER.name') }}</vs-th>
          <vs-th>{{ $t('USER.role') }}</vs-th>
          <vs-th>{{ $t('USER.status') }}</vs-th>
          <vs-th>{{ $t('USER.lastLogin') }}</vs-th>
          <vs-th class="text-center">{{ $t('USER.admin') }}</vs-th>
          <vs-th>{{ $t('USER.actions') }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="(row) in data" :key="row.hash">
            <vs-td :data="row.username" class="username-and-photo-column">
              <img class="img-profile" :src="row.photo ? `${row.photo}` : '@/assets/images/profile/user-uploads/user_default.png'" alt="">
              {{ row.username }}
              <!-- <CellRendererLink :params="{ value: row.username, data: row, node: { data: row } }" /> -->
            </vs-td>

            <vs-td :data="row.name">
              {{ row.name }}
            </vs-td>

            <vs-td :data="row.role">
              <!-- <CellRendererRole :params="{ value: row.role, data: row, node: { data: row } }" /> -->
              {{ row.role ? row.role.name : '' }}
            </vs-td>

            <vs-td :data="row.status_name">
              <!-- <CellRendererStatus :params="{ value: row.status_name, data: row, node: { data: row } }" /> -->
              <span :class="row.status_id === 1 ? 'background-success' : 'background-danger'">
                {{ row.status_name }}
              </span>
              <!-- <vs-alert v-if="row.status_id === 1" color="success" active="true">
                <span>{{ row.status_name }}</span>
              </vs-alert>
              <vs-alert v-if="row.status_id === 2" color="danger" active="true">
                <span>{{ row.status_name }}</span>
              </vs-alert> -->
            </vs-td>

            <vs-td :data="row.last_login_at">
            <span>
              <span :class="getLoginClass(row.last_login_at)">
                {{ formatRelativeTime(row.last_login_at) }}
              </span>
            </span>
          </vs-td>

            <vs-td :data="row.is_admin">
              <!-- <CellRendererVerified :params="{ value: row.is_admin, data: row, node: { data: row } }" /> -->
              <!-- {{ row.is_admin }} -->
              <svg v-if="row.is_admin" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check is-admin">
                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
              </svg>

              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x is-not-admin" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>

            </vs-td>

            <vs-td>
              <!-- <CellRendererActions :params="{ value: null, data: row, node: { data: row } }" /> -->
              <div style="display: flex;" :style="{ 'direction': $vs.rtl ? 'rtl' : 'ltr' }">
                <vx-tooltip v-if="row.status_id === 1" class="mr-4" color="primary" :text="$t('USER.Edit')" position="bottom">
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                    @click="editRecord(row.hash)" />
                </vx-tooltip>

                <vx-tooltip v-if="row.email !== $store.state.auth.user.email" class="mr-4" color="primary" :text="$t('USER.Delete')" position="bottom">
                  <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                    @click="confirmDeleteRecord(row.hash)" />
                </vx-tooltip>

                <vx-tooltip v-if="row.email !== $store.state.auth.user.email" color="primary" :text="row.status_id === 1 ? $t('USER.deactivate') : $t('USER.activate')" position="bottom">
                  <feather-icon :icon="row.status_id === 1 ? 'LockIcon' : 'UnlockIcon'"
                    :svgClasses="row.status_id === 1 ? 'h-5 w-5 cursor-pointer hover:text-danger' : 'h-5 w-5 cursor-pointer hover:text-success'"
                    @click="changeUserStatus(row)" />
                </vx-tooltip>

                <vx-tooltip color="primary" :text="$t('USER.resetPassword')" position="bottom">
                  <feather-icon icon="KeyIcon" svgClasses="h-5 w-5 hover:text-warning cursor-pointer"
                    :class="{ 'ml-3': row.email !== $store.state.auth.user.email }" @click="showResetPasswordForm(row.hash)"
                  />
                </vx-tooltip>

                <vs-popup class="users-list" title="Migrar registros" :active.sync="showMigrateRecordsModal">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <label class="vs-input--label">Selecione um usuário:</label>
                      <div @click="onSelectClick">
                        <v-select :closeOnSelect="true" :clearable="false" v-model="userToMigrate" label="name"
                          :options="usersList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                      </div>
                      <div id="blank_content" style="height: 1px;" v-show="showBlankContent"></div>
                      <vs-button style="float: right!important;" class="ml-auto mt-2"
                        @click="migrateRecords(row.hash)">Migrar</vs-button>
                    </div>
                  </div>
                </vs-popup>
              </div>


            </vs-td>
          </vs-tr>
        </template>

      </vs-table>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>

</template>

<script>
// import { AgGridVue } from 'ag-grid-vue'
// import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

// Cell Renderer
import { performFetch } from '../../../helpers'


export default {
  components: {
    // AgGridVue,
    vSelect,
  },
  data () {
    return {
      showBlankContent: false,
      usersList: [],
      userToMigrate: {},
      showMigrateRecordsModal: false,
      resetPasswordOption: 1,
      newPassword: '',
      retypeNewPassword: '',
      forceUserToChange: true,

      statusFilter: { label: this.$t('USER.all'), value: 'all' },
      statusOptions: [
        { label: this.$t('USER.all'), value: 'all' },
        { label: this.$t('USER.active'), value: 'active' },
        { label: this.$t('USER.deactivated'), value: 'deactivated' },
        { label: this.$t('USER.blocked'), value: 'blocked' }
      ],

      isVerifiedFilter: { label: this.$t('USER.all'), value: 'all' },
      isVerifiedOptions: [
        { label: this.$t('USER.all'), value: 'all' },
        { label: this.$t('USER.yes'), value: 'yes' },
        { label: this.$t('USER.no'), value: 'no' }
      ],

      searchQuery: '',

      // vs-table state
      pageSize: 10,
      currentPageLocal: 1,
      searchText: '',
      currentUserToDeleteHash: ''
      // cell components are registered in the component's components section
    }
  },
  watch: {
    async showMigrateRecordsModal (value) {
      if (value) {
        this.$vs.loading({ type: 'default' })
        await this.getUsersList()
        this.$vs.loading.close()
      }
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    showResetPasswordModal: {
      get () {
        return this.$store.state.userManagement.showResetPasswordModal
      },
      set (value) {
        if (value === false) {
          this.$store.commit('userManagement/SET_CURRENT_USER_TO_CHANGE_PASSWORD', null)
        }
        //this.resetResetPasswordForm()
        this.$store.commit('userManagement/SET_SHOW_RESET_PASSWORD_MODAL', value)
      }
    },
    usersData () {
      return this.$store.state.userManagement.users
    },
    paginationPageSize () {
      return this.pageSize
    },
    totalPages () {
      return Math.ceil(this.filteredUsers.length / this.pageSize)
    },
    currentPage: {
      get () {
        return this.currentPageLocal
      },
      set (val) {
        this.currentPageLocal = val
      }
    },
    filteredUsers () {
      if (!this.searchQuery) return this.usersData || []
      const q = this.searchQuery.toLowerCase()
      return (this.usersData || []).filter(u => {
        return (u.username && u.username.toLowerCase().includes(q)) || (u.name && u.name.toLowerCase().includes(q)) || (u.role && u.role.name && u.role.name.toLowerCase().includes(q))
      })
    },
    pagedUsers () {
      const start = (this.currentPageLocal - 1) * this.pageSize
      return this.filteredUsers.slice(start, start + this.pageSize)
    }
  },
  methods: {
    formatRelativeTime (date) {
      if (!date) return this.$t('USER.neverLogged')

      const d = new Date(date)
      const now = new Date()
      const diff = Math.floor((now - d) / 1000)

      if (diff < 60) return this.$t('USER.justNow')

      if (diff < 3600) {
        const minutes = Math.floor(diff / 60)
        return `${minutes} ${this.$t('USER.minutesAgo')}`
      }

      if (diff < 86400) {
        const hours = Math.floor(diff / 3600)
        return `${hours} ${this.$t('USER.hoursAgo')}`
      }

      if (diff < 604800) {
        const days = Math.floor(diff / 86400)
        return `${days} ${this.$t('USER.daysAgo')}`
      }

      // Para datas mais antigas, exibe a data completa
      return d.toLocaleDateString()
    },

    getLoginClass (date) {
      if (!date) return 'text-gray-400'
      const d = new Date(date)
      const now = new Date()
      const diffDays = Math.floor((now - d) / (1000 * 60 * 60 * 24))

      if (diffDays < 1) return 'text-green-500 font-semibold'
      if (diffDays < 7) return 'text-orange-500'
      return 'text-red-500'
    },
    onSelectClick () {

      if (!this.showBlankContent) {

        try {
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content').style.height = `${offsetHeight  }px`

          this.showBlankContent = true
        } catch (e) {
          //
        }
      }
    },
    showResetPasswordForm (userHash) {
      this.$store.commit('userManagement/SET_SHOW_RESET_PASSWORD_MODAL', !this.$store.state.userManagement.showResetPasswordModal)
      this.$store.commit('userManagement/SET_CURRENT_USER_TO_CHANGE_PASSWORD', userHash)
      // this.$vs.dialog({
      //   type: 'confirm',
      //   color: 'primary',
      //   title: 'Resetar senha do usuário',
      //   text: `You are about to delete "${this.params.data.email}"`,
      //   accept: this.deleteRecord,
      //   acceptText: 'Delete'
      // })
    },
    editRecord (userHash) {
      this.$router.push(`/users/edit/${userHash}`).catch(() => {})
    },
    async changeUserStatus (row) {
      this.$vs.loading({
        type: 'default'
      })
      await fetch(this.$store.state.auth.api_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          command: 'update_application_user', //delete_user
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user: {
              hash: row.hash,
              name: row.name,
              mobile: row.mobile,
              languages: row.languages,
              role: row.role,
              is_admin: row.is_admin,
              status_id: row.status_id === 1 ? 2 : 1
            }
          }
        })
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {
              this.$store.dispatch('userManagement/fetchUsers')
                .then(() => {
                  this.$vs.loading.close()
                })
                .catch(err => {
                  console.error(err)
                  this.$vs.loading.close()
                })
              this.$vs.notify({
                title: this.$t('USER.operationPerformed'),
                text: row.status_id === 1 ? this.$t('USER.DisabledUser') : this.$t('USER.ActivatedUser'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('USER.operationNotPerformed'),
              text: this.$t('USER.UserUpdateError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER.operationNotPerformed'),
            text: this.$t('USER.UserRegisterError'),
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })
    },
    async getUsersList (userHash) {
      return new Promise(async (resolve, reject) => {
        // await fetch(this.$store.state.auth.api_url, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'get_application_users',
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token
        //     }
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
          command: 'get_application_users',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
          .then(async response => {
            if (response.status === 200) {
              await response.json().then(result => {
                const usersList = []
                const users = result.users

                users.forEach(user => {

                  if (user.hash !== userHash) {
                    const userObject = {
                      hash: user.hash,
                      name: user.name
                    }

                    usersList.push(userObject)
                  }
                })

                this.usersList.sort((a, b) => {
                  if (a.name > b.name) {
                    return 1
                  }

                  if (a.name < b.name) {
                    return -1
                  }

                  return 0
                })

                this.usersList = usersList

                this.userToMigrate = this.usersList[0]

                resolve(true)
              })
            }
          })
          .catch(e => console.log(e))
      })
    },
    resetUserPassword () {
      this.$vs.loading({ type: 'default' })

      fetch(this.$store.state.auth.api_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          command: 'reset_user_password', //delete_user
          parameters: {
            application_token: this.$store.state.auth.app_token,
            user_email: this.params.data.email
          }
        })
      })
        .then(response => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('USER.operationPerformed'),
              text: 'User password successfully reset',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          }
        })
        .catch(e => console.log(e))
    },
    migrateRecords (userHash) {
      this.showMigrateRecordsModal = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: 'Você tem certeza que deseja excluir este usuário?',
        accept: () => this.deleteRecord(userHash),
        acceptText: 'Delete'
      })
    },
    deleteRecord (userHash) {
      /* Below two lines are just for demo purpose */

      this.$vs.loading({
        type: 'default'
      })

      fetch(this.$store.state.auth.api_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          command: 'delete_application_user',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user_hash: userHash,
            user_to_migrate_hash: this.userToMigrate.hash
          }
        })
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {
              this.showDeleteSuccess()
              this.$store.dispatch('userManagement/fetchUsers')
                .then(() => {
                  this.$vs.loading.close()
                })
                .catch(err => { console.error(err) })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('USER.operationNotPerformed'),
              text: 'An error occurred while deleting the User',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER.operationNotPerformed'),
            text: 'An error occurred while deleting the User',
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    validateStrengthPassword () {
      const passw = /^(?=.*\d)(?=.*[a-z])(?=.*[@$!%*#?&+])(?=.*[A-Z]).{6,20}$/

      if (this.newPassword !== this.retypeNewPassword) {
        this.$vs.notify({
          title: this.$t('USER.attention'),
          text: this.$t('USER.passwordsDoNotMatch'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }

      if (this.newPassword.match(passw)) {
        return true
      } else if (!this.newPassword.match(passw)) {
        this.$vs.notify({
          title: this.$t('USER.attention'),
          text: this.$t('USER.passwordRequirements'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }

      if (this.retypeNewPassword.match(passw)) {
        return true
      } else {
        this.$vs.notify({
          title: this.$t('USER.attention'),
          text: this.$t('USER.passwordRequirements'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
    },
    async resetUserPassword () {

      if (this.resetPasswordOption == 2) {
        if (!this.validateStrengthPassword()) return
      }

      this.$vs.loading({ type: 'default' })

      const body = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        user_hash: this.$store.state.userManagement.currentUserToChangePassword,
        password: this.newPassword,
        force_user_change_password: this.forceUserToChange,
        send_reset_link: this.resetPasswordOption == 1
      }

      if (this.resetPasswordOption == 1) {
        delete body['password']
      }

      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'reset_user_password',
        parameters: body
      })
        .then((response) => {
          if (response.status === 200) {
            let text = ''

            if (this.resetPasswordOption == 1) {
              text = this.$t('USER.passwordResetLinkSent')
            } else {
              text = this.$t('USER.passwordResetSuccess')
            }

            this.$store.commit('userManagement/SET_CURRENT_USER_TO_CHANGE_PASSWORD', null)
            this.$store.commit('userManagement/SET_SHOW_RESET_PASSWORD_MODAL', false)

            this.$vs.notify({
              title: this.$t('USER.operationSuccessful'),
              text,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.notify({
              title: this.$t('USER.operationUnsuccessful'),
              text: this.$t('USER.passwordResetError'),
              iconPack: 'feather',
              icon: 'icon-info',
              color: 'danger'
            })
          }
          //this.resetResetPasswordForm()
          this.$vs.loading.close()
        })
        .catch(err => {
          this.$vs.notify({
            title: this.$t('USER.operationUnsuccessful'),
            text: this.$t('USER.passwordResetError'),
            iconPack: 'feather',
            icon: 'icon-info',
            color: 'danger'
          })
          //this.resetResetPasswordForm()
          this.$vs.loading.close()
        })
    },
    confirmDeleteRecord (userHash) {

      this.$vs.dialog({
        color: 'warning',
        title: 'Atenção!',
        text: 'É necessário migrar os registros associados para outro usuário.',
        accept: () => this.acceptMigrateUser(userHash),
        acceptText: 'Ok',
        buttonCancel: true,
        cancel: this.cancelMigrateUser
      })
    },
    acceptMigrateUser (userHash) {
      this.currentUserToDeleteHash = userHash
      this.showMigrateRecordsModal = true
    },
    cancelMigrateUser () {},
    // Rest of the methods...

    setColumnFilter (column, val) {
      // For vs-table we filter via computed filteredUsers; map column filters to searchText or advanced filters if needed
      if (column === 'status') {
        // apply simple status filter by reassigning usersData to filtered set if necessary - not implemented complex filters here
        // Keep placeholder for future extension
      }
    },
    resetColFilters () {
      // Reset filter options
      this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: this.$t('USER.all'), value: 'all' }
      this.searchQuery = ''
      this.currentPageLocal = 1
      if (this.$refs.filterCard && this.$refs.filterCard.removeRefreshAnimation) this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.searchQuery = val
      this.currentPageLocal = 1
    }
  },
  mounted () {
    console.log('here 1')
    document.title = `${document.title.split(' | ')[0]} | ${this.$t('USER.users')}`
  },
  created () {
    this.$vs.loading({
      type: 'default'
    })

    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers')
      .then(() => {
        this.$vs.loading.close()
      })
      .catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.username-and-photo-column {
 display: flex;
}
.username-and-photo-column > span {
  display: flex;
  align-items: center;
}
.img-profile {
  max-height: 2rem;
  max-width: 2rem;
  margin-right: .5rem;
}
.is-admin {
  color: rgb(115, 103, 240) !important;
  background-color: rgba(115, 103, 240, 0.377);
  // color: rgb(0, 192, 0) !important;
  // background-color: rgba(0, 209, 0, 0.377);
  border-radius: 8px;
}

.is-not-admin {
  color: rgb(255, 0, 0) !important;
  background-color: rgba(255, 0, 0, 0.377);
  border-radius: 8px;
}

.background-success {
  color: rgb(40 199 110) !important;
  background-color: rgb(40, 199, 110, 0.15) !important;
  border-radius: 8px;
  padding: 0.2rem .6rem;
  font-weight: 500;
}

.background-danger {
  color: rgb(255 40 40) !important;
  background-color: rgb(251 170 170 / 38%);
  border-radius: 8px;
  padding: 0.2rem .6rem;
  font-weight: 500;
}

.text-green-500 {
  color: rgb(40 199 110) !important;
}

.text-orange-500 {
  color: rgb(255, 165, 0) !important;
}
.text-red-500 {
  color: rgb(255, 0, 0) !important;
}
.text-gray-400 {
  color: rgb(156, 163, 175) !important;
}
</style>
